import React from "react";

const Social = () => {
	return (
		<div className="home_social">
			<a
				href="https://www.linkedin.com/in/vishaldinesh/"
				className="home_social-icon"
				target="_blank"
			>
				<i className="uil uil-linkedin-alt"></i>
			</a>
			<a
				href="https://github.com/viz404"
				className="home_social-icon"
				target="_blank"
			>
				<i className="uil uil-github-alt"></i>
			</a>
			<a
				href="https://twitter.com/VishalDinesh15"
				className="home_social-icon"
				target="_blank"
			>
				<i className="bx bxl-twitter"></i>
			</a>
		</div>
	);
};

export default Social;
